'use strict';

var date = new Date();

module.exports = function ( timestamp, months ) {
    var month;

    // console.log(JSON.stringify(days));
    // console.log(JSON.stringify(months));
    // date.setTime(timestamp);
    // day = days[date.getDay()];
    month = months[date.getMonth()];

    return date.getDate() + ' ' + month;
};
